import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { HeadingType } from '@as-react/common-types';
import { Box, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
const headingSizeMap = {
    [HeadingType.EXTRA_TITLE]: 'headingM',
    [HeadingType.TITLE]: 'headingM',
    [HeadingType.SUBTITLE]: 'headingS',
    [HeadingType.SMALL_TITLE]: 'subheadingL',
    [HeadingType.EXTRA_SMALL_TITLE]: 'subheadingM',
};
const BoxedTitle = ({ heading, queryValue, headingOne, headingSize, leadingSpaceNeeded }) => {
    const { t } = useTranslation(I18N_NAMESPACES.navigation);
    return (_jsx(Box, { paddingInlineStart: {
            base: leadingSpaceNeeded ? '4' : '0',
            md: leadingSpaceNeeded ? '6' : '0',
            lg: leadingSpaceNeeded ? '8' : '0',
        }, paddingInlineEnd: "4", paddingBlockEnd: { lg: '4' }, children: _jsxs(TextAlpha, { as: headingOne ? 'h1' : 'h2', variant: headingSizeMap[headingSize], children: [`${heading} `, t('boxed-title.search-term'), ` ${queryValue}`] }) }));
};
export default BoxedTitle;
